import { render, staticRenderFns } from "./type-writer.vue?vue&type=template&id=48c50413&scoped=true"
import script from "./type-writer.vue?vue&type=script&lang=js"
export * from "./type-writer.vue?vue&type=script&lang=js"
import style0 from "./type-writer.vue?vue&type=style&index=0&id=48c50413&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c50413",
  null
  
)

export default component.exports